










































import { Component, Prop, Vue } from 'vue-property-decorator'
import GraphQLSidebar from '@/components/graphql/shared/Sidebar.vue'
import Graphiql from '@/components/graphql/shared/Graphiql.vue'
import apis from '@/lib/api_repository'
import { Field } from '@/types/graphql'

@Component({ components: { GraphQLSidebar, Graphiql } })
export default class GraphQLAPI extends Vue {
  @Prop({ required: true }) api!: string

  authVisible = true
  envVisible = true
  codeCols = 3
  loading = true
  environment = ''
  private auth = ''
  private field: Field | null = null

  ALL_ENVIRONMENTS = [
    { value: 'https://training.knowbe4.com', text: 'US' },
    { value: 'https://eu.knowbe4.com', text: 'EU' },
    { value: 'https://ca.knowbe4.com', text: 'CA' },
    { value: 'https://uk.knowbe4.com', text: 'UK' },
    { value: 'https://de.knowbe4.com', text: 'DE' },
    { value: 'https://training-staging.knowbe4.com', text: 'Staging' },
    { value: 'http://localhost:3000', text: 'Localhost' }
  ]

  get authentication (): string {
    return this.auth || (this.auth = sessionStorage.getItem('papi'))
  }

  set authentication (auth: string) {
    this.auth = auth
    if (auth) sessionStorage.setItem('papi', auth)
    else sessionStorage.removeItem('papi')
  }

  get environments () {
    const allEnvs = process.env.VUE_APP_GRAPHQL_URLS.split(',')

    return this.ALL_ENVIRONMENTS.filter(env => allEnvs.includes(env.value))
  }

  get client () {
    return apis.client(this.api)
  }

  async mounted () {
    this.environment = this.environments[0].value
    if (!this.$route.params.name) this.$router.replace({ name: 'page', params: { name: 'Introduction' } })
    await apis.client(this.api).fetchSchema()
    this.loading = false
  }

  codeToggle (): void {
    this.codeCols = this.codeCols === 3 ? 4 : 3
  }

  tryField (field: Field): void {
    this.field = field
  }
}
